import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchAdmissionFormDetails = createAsyncThunk(
  "admissionForm/fetchAdmissionFormDetails",
  async (_, thunkAPI) => {
    try {
      const response = await axios.post(
        `${server}/get_admissionForm_data_mongodb`,
        {},
        {
          headers: { Authorization: `${localStorage.getItem("token")}` },
        }
      );

      const responseData = response.data?.["body-json"]?.body;

      if (Array.isArray(responseData)) {
        return responseData;
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching admission form details:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const admissionFormSlice = createSlice({
  name: "admissionForm",
  initialState: {
    data: [],
    loading: false,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdmissionFormDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchAdmissionFormDetails.fulfilled, (state, action) => {
        state.data = action.payload.slice().reverse();
        state.loading = false;
      })
      .addCase(fetchAdmissionFormDetails.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default admissionFormSlice.reducer;
